import {Document, Element, isObject, isString} from "@acng/frontend-bounty/types";
import {adoptNode, append} from "@acng/frontend-bounty";
import {queryAll} from "@acng/frontend-bounty/dom/query.js";
import {TAGNAME_TEMPLATE} from "@acng/frontend-bounty/dom/type.js";

import {findOrCreate} from "./find-or-create.js";

/**
 * @param {HTMLTemplateElement} namespace
 * @param {Document | HTMLElement | Object | string} item
 * @param {string[]} path
 * @todo TODO insert HTMLTemplateElement
 * @todo TODO may insert with resource[RESOURCE_COMPILE] = resolved([])
 */
export const insert = (namespace, item, path) => {
  if (item instanceof Document) {
    for (const template of queryAll(item, TAGNAME_TEMPLATE)) {
      append(namespace.content, adoptNode(template));
    }
  } else if (item instanceof Element) {
    const resource = findOrCreate(namespace, path);
    append(resource.content, item);
  } else if (isObject(item)) {
    createTemplatesFromObject(namespace, item);
  } else if (isString(item)) {
    const resource = findOrCreate(namespace, path);
    resource.innerHTML = item;
  } else {
    ASSERT: console.warn("nothing inserted", {namespace, item, path});
  }
};

/**
 * Existing resources will not be inserted.
 *
 * @param {object} translations
 * @param {HTMLTemplateElement} namespace
 */
const createTemplatesFromObject = (namespace, translations) => {
  for (const [key, item] of Object.entries(translations)) {
    const resource = findOrCreate(namespace, [key]);
    if (isString(item)) {
      if (!resource.content.childNodes.length) {
        append(resource.content, item);
      }
    } else {
      createTemplatesFromObject(resource, item);
    }
  }
};
